import Filter from "../Generic/Filter";

export default function PositionFilter() {
  const title = "Position";
  const attribute = "string.position";
  const options = { attribute, title };

  return <Filter {...options} />;
}
